import React, { Component, PropTypes } from 'react';
// import { Link } from 'react-router';
import axios from 'axios';

import baseUrl from '../../../utils/baseUrl';

// import Splitter from '../block/splitter';
import ContentBlock from '../block/content';
import ConfirmDialog from '../../form/confirm';
import FormFitter from '../../form/decorators/formfitter';

import Form from '../../form/form';
import InputText from '../../form/input/text';
import InputTextarea from '../../form/input/textarea';
import InputDropzone from '../../form/dropzone/dropzone';
// import InputDropzoneVideo from '../../form/dropzone/dropzoneVideo';
import InputDropzoneGrid from '../../form/dropzone/dropzoneGrid';
import InputTagSelect from '../../form/tagselect/tagselect';
import Label from '../../form/label';
import Select from '../../form/select/select';
import InputMultiCheckbox from '../../form/input/multicheckbox';

import caseExtraImg from './case-extra.png';

import css from './devicepicker.scss';

import InputCheckbox from '../../form/input/checkbox';
import DEVICE_DESKTOP_ICON from './device_d.png';
import DEVICE_TABLET_PORTRAIT_ICON from './device_tp.png';
import DEVICE_TABLET_LANDSCAPE_ICON from './device_tl.png';
import DEVICE_MOBILE_PORTRAIT_ICON from './device_mp.png';
import DEVICE_MOBILE_LANDSCAPE_ICON from './device_ml.png';

import translate from '../../../utils/translate';
// import * as actions from '../../actions/account';
// const MOBILE = 'Mobile';
// const TABLET = 'Tablet';
// const DESKTOP = 'Desktop';

import {
	DEVICE_DESKTOP,
	DEVICE_TABLET_PORTRAIT,
	DEVICE_TABLET_LANDSCAPE,
	DEVICE_MOBILE_PORTRAIT,
	DEVICE_MOBILE_LANDSCAPE,
} from '../../../constants/types';

export default class CaseEditForm extends Component {
	static propTypes = {
		dispatch: PropTypes.func.isRequired,
		smallAside: PropTypes.bool.isRequired,
		path: PropTypes.string.isRequired,
		method: PropTypes.string.isRequired,

		head: PropTypes.oneOfType([
			PropTypes.oneOf([false]),
			PropTypes.object,
		]).isRequired,
		foot: PropTypes.oneOfType([
			PropTypes.oneOf([false]),
			PropTypes.object,
		]).isRequired,

		case: PropTypes.object,

		onSubmit: PropTypes.func.isRequired,
	};

	static defaultProps = {
		smallAside: false,
		path: '',
		method: 'put',

		head: false,
		foot: false,
		case: {},

		onSubmit: () => {},
	};

	constructor(props) {
		super();

		this.mounted = true;

		this.state = {
			profileCreated: false,
			types: [],
			categories: [],
			selectedType: props.case.typeId || false,
			selectedDevice: props.case.bestViewedOn || DEVICE_DESKTOP,
		};
	}

	componentWillMount() {
		axios.all([
			axios.get(`${baseUrl}/api/account/projects/types`),
			axios.get(`${baseUrl}/api/account/projects/categories`),
		])
		.then(axios.spread((typesResponse, categoriesResponse) => {
			const newState = { ...this.state };
			if (typesResponse.data && typesResponse.data.types) {
				newState.types = ((types) => {
					const formattedTypes = [];

					for (let i = 0; i < types.length; i++) {
						// let optimizedFor = [];
						//
						// types[i].desktop && optimizedFor.push(DESKTOP);
						// types[i].tablet && optimizedFor.push(TABLET);
						// types[i].mobile && optimizedFor.push(MOBILE);
						//
						// if (!types[i].desktop && !types[i].tablet && !types[i].mobile) {
						// 	// if none are selected in CMS.. add desktop anyway -- REBEL!
						// 	optimizedFor.push(DESKTOP);
						// }

						formattedTypes.push({
							id: types[i].id,
							value: types[i].id,
							label: types[i].name,
							// optimizedFor: optimizedFor,
							desktop: !!types[i].desktop,
							tablet: !!types[i].tablet,
							mobile: !!types[i].mobile,
						});
					}
					return formattedTypes;
				})(typesResponse.data.types);
			}

			if (categoriesResponse.data && categoriesResponse.data.categories) {
				newState.categories = ((categories) => {
					const formattedCategories = [];
					for (let i = 0; i < categories.length; i++) {
						formattedCategories.push({
							id: categories[i].id,
							label: categories[i].name,
						});
					}
					return formattedCategories;
				})(categoriesResponse.data.categories);
			}

			this.mounted && this.setState(newState);
		}))
		.catch(() => {
			// console.log(res);
		});
	}

	componentWillUnmount() {
		this.mounted = false;
	}

	render() {
		const uploadSize = this.getUploadSize();
		const type = this.findType(this.state.selectedType);
		return (
			<Form
				dispatch={this.props.dispatch}
				getRefs={() => this.getRefs()}
				method={this.props.method}
				action={this.props.path}
				smallAside={this.props.smallAside}
				onSubmit={this.props.onSubmit}
				head={this.props.head}
				ref='form'
			>
				<ContentBlock title='Basic description' smallAside={this.props.smallAside}>
					<FormFitter className='span3 span5-tablet span11-mobile'>
						<InputText ref='title' name='title' value={this.props.case.title} label='Project name' />

						<Label label='Project Type' />
						<Select
							ref='typeId'
							name='typeId'
							value={this.props.case.typeId}
							options={this.state.types}
							placeholder='Select project type'
							onChange={(val) => this.setState({ ...this.state, selectedType: val })}
						/>
					</FormFitter>

					{(!!type) && (
						<FormFitter className='span100p'>
							<Label label='Device to be judged on' />
							<DevicePicker
								ref='bestViewedOn'
								name='bestViewedOn'
								{...type}
								value={this.props.case.bestViewedOn}
								onChange={(val) => this.setState({ ...this.state, selectedDevice: val })}
							/>
						</FormFitter>
					)}

					<FormFitter className='span5 span5-tablet span11-mobile'>
						<InputTextarea ref='description' name='description' value={this.props.case.description} label='Short description' maxChars={300} rows={6} />
					</FormFitter>

					<FormFitter className='span3 span5-tablet span11-mobile'>
						<InputText ref='url' name='url' value={this.props.case.url} label='Project URL' btw=' or case study URL for installations etc.' />
					</FormFitter>

				</ContentBlock>

				<ContentBlock title='Credits' smallAside={this.props.smallAside}>
					<Label label='FWA Profile min. 1 required' btw=' - all credited profiles will be able to edit the project after submission' />
					<FormFitter className='span3 span5-tablet span11-mobile'>
						<ConfirmDialog ref='confirm' />
						<InputTagSelect
							ref='credits'
							name='credits'
							value={this.props.case.credits}
							placeholder='Type to search for FWA Profiles'
							path='/api/profiles/search'
							showLink
							link={{
								url: `${baseUrl}/account/profile/settings/`,
								text: 'Create new',
								onClick: (e, val, createEntry) => {
									e.preventDefault();
									const breakRegex = /<br\s*[\/]?>/gi;

									if ((this.props.user && !this.props.user.profile) && !this.state.profileCreated) {
										const confirmText = translate('account/casecreate/addProfilePopup', false).replace('%name%', val).replace(breakRegex, '\n');
										const buttonOk = 'Yes, create profile';
										const buttonCancel = 'No, just add a credit';

										this.refs.confirm.confirm(confirmText, buttonOk, buttonCancel)
										.then(() => {
											this.setState({
												...this.state,
												profileCreated: true,
											});
											createEntry({
												myProfile: 1,
												onDelete: () => {
													this.setState({
														...this.state,
														profileCreated: false,
													});
												}
											});
										})
										.catch((res) => {
											if (res.status !== 'CLOSED') {
												createEntry();
											}
										});
									} else {
										const confirmText = translate('account/casecreate/addCreditPopup', false).replace('%name%', val).replace(breakRegex, '\n');
										const buttonOk = 'Yes, add a credit';
										const buttonCancel = 'Cancel';

										this.refs.confirm.confirm(confirmText, buttonOk, buttonCancel)
										.then(() => {
											createEntry();
										})
										.catch(() => {});
									}
								},
							}}
							onChange={() => {}}
						/>
					</FormFitter>

					<div className='cf' />
					<InputText ref='createUserProfile' name='createUserProfile' type='hidden' value={this.state.profileCreated ? 1 : 0} />
				</ContentBlock>

				<ContentBlock title='Categories' smallAside={this.props.smallAside}>
					<Label label='Project categories' btw=' - Min. 1 - max. 3' />
					<FormFitter className='span6 span8-tablet span100p-mobile'>
						<div className='cf'></div>
						<InputMultiCheckbox
							name='categories'
							ref='categories'
							value={this.props.case.categories}
							maxChecked={3}
							options={this.state.categories}
						/>

					</FormFitter>
				</ContentBlock>

				<ContentBlock title='Basic visuals' smallAside={this.props.smallAside}>
					<FormFitter className='span6 span100p-tablet span100p-mobile'>
						<Label
							label='Project Thumbnail'
							btw={' 1076 · 672 jpg / png'}
							helpText={translate('account/casecreate/thumbnailHelpText', true, false)}
						/>
						<InputDropzone
							ref='thumbnail'
							aspect={672 / 1076}
							width={270}
							path={`${this.props.path}/image`}
							inputs={[
								{ name: 'thumbnail', preview: this.getFirstImage(this.props.case.thumbnail) },
							]}
							params={{
								device: this.state.selectedDevice || DEVICE_DESKTOP,
							}}
							accept='image/*'
							recommended={{
								width: 1076,
								height: 672,
							}}
							disableDelete
						/>
					</FormFitter>

					<FormFitter className='span100p'>
						<Label label='3 Project slide' btw={` ${uploadSize.width} · ${uploadSize.height} jpg / png`} helpText={translate('account/casecreate/slidesHelpText', true, false)} />
						<InputDropzone
							ref='slides'
							aspect={747 / 1169}
							width={270}
							path={`${this.props.path}/image`}
							inputs={[
								{ name: 'slide1', preview: this.getFirstImage(this.props.case.slide1) },
								{ name: 'slide2', preview: this.getFirstImage(this.props.case.slide2) },
								{ name: 'slide3', preview: this.getFirstImage(this.props.case.slide3) },
							]}
							params={{
								device: this.state.selectedDevice || DEVICE_DESKTOP,
							}}
							accept='image/*'
							recommended={{
								width: uploadSize.width,
								height: uploadSize.height,
							}}
							disableDelete
						/>
					</FormFitter>

					<FormFitter className='span3 span5-tablet span11-mobile'>
						<InputText ref='showreelUrl' name='showreelUrl' value={this.props.case.showreelUrl} label='PROJECT DEMO REEL/VIDEO' btw=' Optional' placeholder='Youtube or Vimeo URL/ID' />
					</FormFitter>
				</ContentBlock>

				<ContentBlock
					title={(
						<span>
							Case extras (optional)<br />
							<span style={{ fontSize: '0.8em' }}>Add extras now, later, or not at all</span>
						</span>
					)}
					smallAside={this.props.smallAside}
				>
					<FormFitter className='span100p account-process__info-section'>
						<div className='span4-desktop span8-tablet span100p-mobile account-process__info-section__text'>
							<h3 className='account-process__info-section__text__head'>{translate('account/casecreate/extraVisualTitle', true, true)}</h3>
							<div className='account-process__info-section__text__content' dangerouslySetInnerHTML={{ __html: translate('account/casecreate/extraVisual', true, false) }} />
						</div>
						<div className='span4-desktop span8-tablet span100p-mobile account-process__info-section__visual'>
							<img {...caseExtraImg} alt='' />
						</div>
						<div className='cf'></div>
					</FormFitter>

					<FormFitter className='span7 span100p-mobile'>
						<InputText ref='extraTitle' name='extraTitle' value={this.props.case.extraTitle} maxChars={300} label='Extra title ' btw=' optional' placeholder={'Extra title'} />
						<InputTextarea
							ref='extraText'
							name='extraText'
							value={this.props.case.extraText}
							maxChars={1000}
							label='Extra text '
							btw=' optional'
							rows={6}
							placeholder={'Add a more elaborate description of your project that reveals, for example, nice details, things to notice or keep in mind. You could also mention the project\'s goals etc.'}
						/>
					</FormFitter>

					<FormFitter className='span100p'>
						<Label label='Extra visuals optional' btw=' 628 · 353 | 877 · 548 jpg / png / mp4' />
						<InputDropzoneGrid
							ref='extras'
							path={`${this.props.path}/image`}
							inputs={[
								{ name: 'extra1',
									aspect: (353 / 628),
									preview: this.getFirstImage(this.props.case.extra1),
									recommended: {
										width: 628,
										height: 353,
									}
								},
								{ name: 'extra2',
									aspect: (353 / 628),
									preview: this.getFirstImage(this.props.case.extra2),
									recommended: {
										width: 628,
										height: 353,
									}
								},
								{ name: 'extra3',
									aspect: (548 / 877),
									preview: this.getFirstImage(this.props.case.extra3),
									recommended: {
										width: 877,
										height: 548,
									}
								},
							]}
							accept='image/*, video/*'
						/>
					</FormFitter>
				</ContentBlock>

				{this.props.foot}
			</Form>
		);
	}

	getFirstImage(img) {
		if (typeof img !== 'object') {
			return '';
		}

		const bps = Object.keys(img);
		const span = Object.keys(img[bps[0]]);
		return img[bps[0]][span[0]];
	}

	getUploadSize() {
		switch (this.state.selectedDevice) {
			case DEVICE_TABLET_PORTRAIT:
				return {
					width: 1536,
					height: 2048,
				};
			case DEVICE_TABLET_LANDSCAPE:
				return {
					width: 2048,
					height: 1536,
				};
			case DEVICE_MOBILE_PORTRAIT:
				return {
					width: 750,
					height: 1334,
				};
			case DEVICE_MOBILE_LANDSCAPE:
				return {
					width: 1334,
					height: 750,
				};
			case DEVICE_DESKTOP:
			default:
				return {
					width: 1169,
					height: 747,
				};
		}
	}

	getRefs() {
		return this.refs;
	}

	findType(val) {
		for (let i = 0; i < this.state.types.length; i++) {
			if (this.state.types[i].id === val) {
				return this.state.types[i];
			}
		}

		return false;
	}

	formatFocusOptions(type) {
		const options = [];

		if (type && type.optimizedFor) {
			for (let i = 0; i < type.optimizedFor.length; i++) {
				options.push({
					id: type.optimizedFor[i],
					value: type.optimizedFor[i],
					label: type.optimizedFor[i],
				});
			}
		}

		return options;
	}
}


class DevicePicker extends Component {
	static propTypes = {
		desktop: PropTypes.bool.isRequired,
		tablet: PropTypes.bool.isRequired,
		mobile: PropTypes.bool.isRequired,
		onChange: PropTypes.func,
		value: PropTypes.string,
	};

	static defaultProps = {
		desktop: true,
		tablet: false,
		mobile: false,
		onChange: () => {},
	};

	constructor(props) {
		super();

		const firstChoice = this.firstChoice(props);
		this.value = firstChoice;

		this.devices = {
			DEVICE_DESKTOP: {
				img: DEVICE_DESKTOP_ICON,
				name: false,
				orientation: 'Desktop',
				title: 'Desktop',
			},
			DEVICE_TABLET_PORTRAIT: {
				img: DEVICE_TABLET_PORTRAIT_ICON,
				name: 'Tablet',
				orientation: 'Portrait',
				title: 'Tablet - Portrait',
			},
			DEVICE_TABLET_LANDSCAPE: {
				img: DEVICE_TABLET_LANDSCAPE_ICON,
				name: 'Tablet',
				orientation: 'Landscape',
				title: 'Tablet - Landscape',
			},
			DEVICE_MOBILE_PORTRAIT: {
				img: DEVICE_MOBILE_PORTRAIT_ICON,
				name: 'Mobile',
				orientation: 'Portrait',
				title: 'Mobile - Portrait',
			},
			DEVICE_MOBILE_LANDSCAPE: {
				img: DEVICE_MOBILE_LANDSCAPE_ICON,
				name: 'Mobile',
				orientation: 'Landscape',
				title: 'Mobile - Landscape',
			},
		};

		this.state = {
			selected: firstChoice,
		};
	}

	componentDidMount() {
		const firstChoice = this.firstChoice(this.props);
		this.value = firstChoice;

		this.props.onChange(firstChoice);
	}

	componentWillReceiveProps(nextProps) {
		if (
			nextProps.desktop !== this.props.desktop ||
			nextProps.tablet !== this.props.tablet ||
			nextProps.mobile !== this.props.mobile
		) {
			const firstChoice = this.firstChoice(nextProps);
			this.value = firstChoice;

			this.props.onChange(firstChoice);

			this.setState({
				...this.state,
				selected: firstChoice,
			});
		}
	}

	render() {
		return (
			<div className='devicepicker pixel-pattern pixel-pattern--01'>
				<div className='devicepicker__inner'>
					{this.renderChoice(DEVICE_DESKTOP, this.props.desktop)}
					{this.renderChoice(DEVICE_TABLET_PORTRAIT, this.props.tablet)}
					{this.renderChoice(DEVICE_TABLET_LANDSCAPE, this.props.tablet)}
					{this.renderChoice(DEVICE_MOBILE_PORTRAIT, this.props.mobile)}
					{this.renderChoice(DEVICE_MOBILE_LANDSCAPE, this.props.mobile)}
					<div className='cf'></div>
				</div>
			</div>
		);
	}

	renderChoice(opt, show) {
		let className = 'devicepicker__inner__item';
		if (show) {
			className += ' devicepicker__inner__item--show';
		}

		let img = this.devices[opt].img;
		let imgTitle = this.devices[opt].title;

		return (
			<div className={className} onClick={() => this.select(opt)}>
				<div className='devicepicker__inner__item__icon'>
					<img {...img} width={img.width / 2} height={img.height / 2} alt={imgTitle} />
				</div>
				<div className='devicepicker__inner__item__name'>{this.devices[opt].name || '\u00a0'}</div>
				<div className='devicepicker__inner__item__orientation'>{this.devices[opt].orientation}</div>
				<div className='devicepicker__inner__item__checkbox'>
					<InputCheckbox name={opt} onChange={() => this.select(opt)} value={this.state.selected === opt} />
				</div>
			</div>
		);
	}

	select(val) {
		this.value = val;
		this.setState({
			...this.state,
			selected: val,
		});
		this.props.onChange(val);
	}

	firstChoice(props) {
		if (props.value) {
			if (props.desktop && props.value === DEVICE_DESKTOP) {
				return props.value;
			} else if (
				props.tablet &&
				(props.value === DEVICE_TABLET_PORTRAIT || props.value === DEVICE_TABLET_LANDSCAPE)) {
				return props.value;
			} else if (
				props.mobile &&
				(props.value === DEVICE_MOBILE_PORTRAIT || props.value === DEVICE_MOBILE_LANDSCAPE)) {
				return props.value;
			}
		}


		if (props.desktop) {
			return DEVICE_DESKTOP;
		} else if (props.tablet) {
			return DEVICE_TABLET_PORTRAIT;
		} else if (props.mobile) {
			return DEVICE_MOBILE_PORTRAIT;
		}

		return DEVICE_DESKTOP;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/account/caseCreate/caseEditForm.js
 **/